import React from "react";
import MemberList from "../../components/MemberList/MemberList";
import InviteNewMembers from "../../components/InviteNewMembers/InviteNewMembers";

const TeamMemberList = () => (
  <div style={{
    maxWidth: "1288px",
    margin: "0 auto 64px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflow: "auto",
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
  }}>
    <InviteNewMembers />
    <MemberList />
  </div>
);
export default TeamMemberList;
